import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

const TechInventorySwap = (props) => {
    const {
        inventory,
        fromTechId,
        fromUserId,
        toTechId,
        currentUserId,
        techInventoryActions,
        inventoryLoading,
        inventoryLoadingFinished,
    } = props;

    let techSections = [];
    const tableStyle = {
        tableLayout: 'fixed'
    };
    const tableCellStyle = {
        whiteSpace: 'normal',
        wordWrap: 'break-word'
    };

    if (inventory && inventory.get('details')) {
        const groupedByTechId = inventory
            .get('details')
            .groupBy((item) => {
                return item
                    .get('techId')
                    .trim();
            });

        groupedByTechId.forEach((techIdGroup, techIdGroupIndex) => {

            const groupedEquipment = techIdGroup.groupBy((item) => {
                return item
                    .get('serialNumber')
                    .trim();
            }).toList();

            const rows = [];

            groupedEquipment.forEach((item, index) => {
                const serialNumber = item
                    .first()
                    .get('serialNumber');
                    const billingSystem = item
                    .first()
                    .get('billingSystem');
                    const status = item
                    .first()
                    .get('status');


                if(status === 'Assigned to Technician' || status ===  '7') {
                    const transferRequest = {
                        billingSystem: billingSystem,
                        fromTechId: fromTechId,
                        toTechId: toTechId,
                        serialNumber: serialNumber
                    };

                    rows.push(
                        <tr key={'inventory_row_' + index}>
                            <td style={tableCellStyle}>
                                {item
                                    .first()
                                    .get('description')}
                            </td>
                            <td>
                                {serialNumber}
                            </td>
                            <td>
                                <RaisedButton
                                    label="Transfer"
                                    key={'inventory_button_' + index}
                                    fullWidth
                                    primary={true}
                                    disabled={!toTechId || !fromTechId}
                                    onTouchTap={() => {
                                    techInventoryActions.transferInventoryStarted(transferRequest);
                                    setTimeout(function () {
                                        techInventoryActions.getTechInventoryStarted({
                                            isSelf: false
                                        }, fromUserId);
                                    }, 10000);
                                    setTimeout(function () {
                                        techInventoryActions.getTechInventoryStarted({
                                            isSelf: false
                                        }, currentUserId);
                                    }, 20000);
                                }}/>
                            </td>
                        </tr>
                    );

                }
            });

            const display = (
                <div key={`tech_inventory_group_${techIdGroupIndex}`}>
                    <h6 className="center-align">From Tech: {fromTechId}</h6>
                    <h6 className="center-align">{fromUserId}</h6>
                    <table style={tableStyle} className="bordered striped wow-fst-equipment-table">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>MAC Address</th>
                                <th>Transfer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                        </tbody>
                    </table>
                </div>
            );

            techSections.push(display);
        });
    }

    if (inventoryLoading && !inventoryLoadingFinished) {
        techSections = (
            <h6 className="wow-fst-no-data-message">Inventory Loading...</h6>
        );
    } else if (!techSections || techSections.length === 0) {
        techSections = (
            <h6 className="wow-fst-no-data-message">No Inventory to Display</h6>
        );
    }

    return (
        <div>
            {techSections}
        </div>
    );
};

TechInventorySwap.propTypes = {
    inventory: PropTypes.object,
    fromUserId: PropTypes.string,
    currentUserId: PropTypes.string,
    toTechId: PropTypes.string,
    fromTechId: PropTypes.string,
    techInventoryActions: PropTypes.object,
    inventoryLoading: PropTypes.bool,
    inventoryLoadingFinished: PropTypes.bool
};

export default TechInventorySwap;


// WEBPACK FOOTER //
// ./src/components/equipment/TechInventorySwap.js